// === Global-form-variables ===
export const formControlColors = () => `
    --form-control-background-color: var(--container-background-color-100);
    --form-control-list-hover-background-color: var(--container-background-hover-color-200);
    --form-control-border-color: var(--container-border-color-100);

    --form-control-label: var(--label-text-color);

    --form-control-dropdown-shadow: var(--container-shadow-color-100 );
    --form-control-dropdown-focus-select: var(--container-background-hover-color-100);

    --form-control-disabled-background-color: var(--container-background-color-disabled-100);
    --form-control-disabled-border-color: var(--container-border-color-100);
    --form-control-disabled-text-color: var(--container-text-color-disabled-100);
    --form-control-disabled-mask-background-color: var(--container-background-mask-color-disabled-100);

    --form-word-fix-background-color: var(--container-background-color-300);
    --form-word-fix-border-color:var(--container-border-color-100);
    --form-word-fix-text-color: var(--label-text-color-200);

    --container-background-focus: var(--container-background-hover-color-100);
    --container-border-focus: var(--container-border-hover-color-100);
    `;

export const inContainerFormControlColors = () => `
    --form-control-background-color: var(--container-background-color-200);
    --form-control-border-color: var(--container-border-color-200);
    --form-word-fix-border-color: var(--container-border-color-200);
    --form-control-disabled-border-color: var(--container-border-color-200);
    --form-word-fix-background-color: var(--container-background-color-500);
`;
